import {createContact, createContactAndAutoConnect, deleteContact, listContacts} from "../../services/apollo/contacts";

export default {
  namespaced: true,
  actions: {
    list({commit}) {
      return listContacts()
        .then((contacts) => {
          commit('setContacts', contacts)
        })

    },
    create({commit}, contactForm) {
      return createContact(contactForm)
        .then(contact => {
          commit('addContact', contact);
          return contact
        })
    },
    createAndAutoConnect({commit}, contactForm) {
      return createContactAndAutoConnect(contactForm)
        .then(autoConnect => {
          console.log(autoConnect)
          commit('addContact', autoConnect.contact);
          return autoConnect
        })
    },
    updateContact({commit}, contact) {
      commit('updateContact', contact);
      commit('call/updateCallContact', contact, {root: true});
    },
    delete({commit}, id) {
      deleteContact(id)
        .then(() => commit('deleteContact', id))
    }
  },
  mutations: {
    addContact(state, contact) {
      state.contacts = [contact, ...state.contacts]
    },
    setContacts(state, contacts) {
      state.contacts = contacts
    },
    updateContact(state, contact) {
      state.contacts = state.contacts.map(c =>
        c.identity === contact.identity
          ? contact
          : c)
    },
    deleteContact(state, id) {
      state.contacts = state.contacts.filter(c => c.id !== id)
    }
  },
  state: {
    contacts: []
  }
}
